export default __webpack_public_path__ + "static/media/Declaration of Independence_01.4cff762e.jpg";